import { useState, useCallback } from 'react';


export default function useSSIDList() {
    const [connectedSSIDInfo, setConnectedSSIDInfo] = useState({
        connected: undefined,
        remembered_password: undefined,
        name: undefined,

        error: undefined,
    })

    const onSSIDRelatedEvent = useCallback((message) => {
        if (message.ev === "ssid_list") {
            let newSSIDs = message.msg.ssids.map((ssid) => {
                return {...ssid, };
            })

            let csl = newSSIDs.filter(ssid => ssid.connected === true);

            if (csl && csl.length > 0) { // at least one is connected
                setConnectedSSIDInfo({
                    connected: true,
                    remembered_password: csl[0].remembered_password,
                    name: csl[0].name,
                    error: undefined,
                });
            } else {
                setConnectedSSIDInfo({
                    connected: false,
                    remembered_password: undefined,
                    name: undefined,
                    error: undefined,
                });
            }
        } else if (message.ev === "connected_ssid"){
            setConnectedSSIDInfo({
                connected: message.msg.connected,
                remembered_password: message.msg.remembered_password,
                name: message.msg.name,
                error: message.msg.error,
            });
        }        
    },[])

    return [connectedSSIDInfo, onSSIDRelatedEvent]
}
